<template>
    <router-view :class="className"></router-view>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        className:''
      }
    },
    beforeMount:function (){  
    	if(localStorage.getItem('lang')){
    		if(localStorage.getItem('lang')=='en'){
    			this.$i18n.locale ='en-US'
    		}else{
    			this.$i18n.locale ='zh-CN'
    		}
    	}
			
	},
  }
</script>

<style>
	@import url("./assets/css/common.css");
	@import url("./assets/css/font-awesome.min.css");

  
  	

</style>
